module.exports = __webpack_public_path__ + "static/hexblood-f7fd65056954ae7048357da14b48c9fa.png";